import { $, $$, isMobile } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-lubes-guide-search]')) return;

  addEventListeners();
}

function addEventListeners() {
  $$('[data-au-lubes-guide-search-nav-toggle-filters]').forEach((searchBarMobile) => {
    searchBarMobile.addEventListener('click', showMultiSearchBarMobile);
  });

  isMobile.addEventListener('change', (e) => {
    if (!e.matches) {
      $$('[data-au-multi-search-bar-main]').forEach((el) => {
        el.classList.remove('au-multi-search-bar__main--visible');
      });
      document.body.classList.remove('au-overflow-hidden');
    }
  });

  toggleRecentSearches();
  newSearch();
  recentCardDatalayer();
  resultCardDatalayer();

  // uncomment to see results when click on search button
  // searchLubesGuide();
}

// function searchLubesGuide() {
//   $$('[data-au-lubes-guide-search] [type="submit"]').forEach((searchBtn) => {
//     searchBtn.addEventListener('click', (e) => {
//       e.preventDefault();

//       e.target
//         .closest('[data-au-lubes-guide-search-tab-content]')
//         .querySelector('[data-au-lubes-guide-search-results]')
//         .classList.remove('au-hide');
//     });
//   });
// }

function showMultiSearchBarMobile(e) {
  if (!isMobile.matches) return;

  const multiSearchBarMain = e.target
    .closest('[data-au-lubes-guide-search]')
    .querySelector('[data-au-multi-search-bar-main]');

  multiSearchBarMain.classList.add('au-multi-search-bar__main--visible');
  document.body.classList.add('au-overflow-hidden');

  const closeButton = multiSearchBarMain.querySelector('[data-au-multi-search-bar-mobile-close]');
  if (closeButton) closeButton.focus();
}

function toggleRecentSearches() {
  const recentSearchsDiv = $('[data-au-lubes-guide-search-hide-recent-searchs]');
  const toggleBtn = $('[data-au-lubes-guide-search-hide-recent-cards]');
  if (!recentSearchsDiv || !toggleBtn) return;

  const altText = toggleBtn.getAttribute('data-au-lubes-guide-search-hide-recent-cards');
  const altIcon = 'visibility';
  const originalText = toggleBtn.querySelector('span:not([data-au-icon])').textContent.trim();
  const originalIcon = 'visibility_off';

  toggleBtn.addEventListener('click', function () {
    recentSearchsDiv.classList.toggle('au-hide');
    const currentText = toggleBtn.querySelector('span:not([data-au-icon])').textContent.trim();
    const currentIcon = toggleBtn.querySelector('[data-au-icon]').textContent.trim();

    toggleBtn.querySelector('span:not([data-au-icon])').textContent =
      currentText === originalText ? altText : originalText;
    toggleBtn.querySelector('[data-au-icon]').textContent = currentIcon === originalIcon ? altIcon : originalIcon;
  });
}

function newSearch() {
  document.addEventListener('click', (e) => {
    const newSearchBtn = e.target.closest('[data-au-lubes-guide-search-new-search]');
    if (!newSearchBtn) return;

    const tab1 = $('[data-au-tab="lubes-guide-search-1"]');
    const tab3 = $('[data-au-tab="lubes-guide-search-3"]');
    const content1 = $('[data-au-tab-content="lubes-guide-search-1"]');
    const content3 = $('[data-au-tab-content="lubes-guide-search-3"]');

    tab3.classList.remove('au-active');
    tab1.classList.add('au-active');
    content1.classList.remove('au-hide');
    content1.classList.add('au-active');
    content3.classList.remove('au-active');
    content3.classList.add('au-hide');

    const favTab = $('[data-au-tab="lubes-guide-search-3"]').innerText;
    const clickText = newSearchBtn.querySelector(':not([data-au-icon])').innerText;

    window.dataLayer.push({
      event: 'navigation',
      content_type: 'clickEnlace',
      item_id: `${removeAccentMarkAndUppercase(favTab)}_${removeAccentMarkAndUppercase(clickText)}`,
    });
  });
}

function recentCardDatalayer() {
  $$('[data-au-lubes-recent-card-link]').forEach((card) => {
    card.addEventListener('click', (e) => {
      const cardTitle = e.target.querySelector(':not([data-au-icon])').innerText;
      const title = e.currentTarget
        .closest('[data-au-lubes-guide-search]')
        .querySelector('[data-au-lubes-guide-search-recent-searches-title]').innerText;

      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickCard',
        item_id: `${removeAccentMarkAndUppercase(title)}_${removeAccentMarkAndUppercase(cardTitle)}`,
      });
    });
  });
}

function resultCardDatalayer() {
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-au-lubes-result-card-link]');
    if (!link) return;

    const card = link.closest('[data-au-lubes-result-card]');
    const brand = card.querySelector('[data-au-lubes-result-card-brand]').innerText;
    const model = card.querySelector('[data-au-lubes-result-card-model]').innerText;
    const displacement = card.querySelector('[data-au-lubes-result-card-displacement]').innerText;
    const year = card.querySelector('[data-au-lubes-result-card-year]').innerText;
    const fuelType = card.querySelector('[data-au-lubes-result-card-fuel-type]').innerText;
    const vehicle = `${brand} ${model} ${displacement} ${year} ${fuelType}`;
    const activeTab = card.closest('[data-au-lubes-guide-search]').querySelector('[data-au-tab].au-active').innerText;
    const item_id = `${removeAccentMarkAndUppercase(activeTab)}_${removeAccentMarkAndUppercase(vehicle)}`;

    // datalayer
    window.dataLayer.push({
      event: 'navigation',
      content_type: 'clickCard',
      item_id,
    });
  });
}

export default { init };
